/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-script-url */
/*
 * @Author: chenyaxuan@leedarson.com
 * @Date: 2019-08-20 12:11:38
 * Copyright © Leedarson. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

const USER_AGENT = navigator.userAgent.toLowerCase();

const isIos = /iphone|ipad|ipod/.test(USER_AGENT);
const isAndroid = /android/.test(USER_AGENT);

const isMobile = isIos || isAndroid;

const ModalButtonByArnoo = ({ children, type, primaryButtons, onTouchEnd }) => {
  return (
    <div
      className="modal-button"
      role="button"
      // buttonType={type}
      // primaryButtons={primaryButtons}
      onClick={isMobile ? undefined : onTouchEnd}
      onTouchEnd={isMobile ? onTouchEnd : undefined}
    >
      {children}
    </div>
  );
};

ModalButtonByArnoo.defaultProps = {
  type: 'confirm',
  primaryButtons: ['confirm'],
  onTouchEnd: () => {},
};

ModalButtonByArnoo.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['cancel', 'confirm']),
  primaryButtons: PropTypes.arrayOf(PropTypes.string),
  onTouchEnd: PropTypes.func,
};

export default ModalButtonByArnoo;
